
import React, { useState, Component } from 'react';
import Chip from '../Atoms/Chip';
import { client } from '../../client';




class FilterSection extends Component {
    // use a constructor if necessary
    constructor(props) {
      super(props);
     
      this.state = {
        tagArr : []
        
      };

    }

   //this is where we receive API calls inside components
   componentDidMount() {
    client.getTags()
    .then((response) => {
        this.setState({
          tagArr : response.items
        })  
      
    })
      

    
    .catch(console.error)
  }

  
    


  // cardData.metadata.tags[0]
  render() {
    
    // console.log(this.state.tagArr)

    return <div aria-label="Categories of work" className="flex justify-content-center h-9 phone-h-15 items-center bb wrap content-center row-gap-xs">
          
          
          
          
          {
            this.state.tagArr.map((tag, index) => (
              <Chip linkTo="../filter/vaerker" content={tag.name} cx="margin-r-s margin-l-s" />
              // <Chip linkTo={onHome ? "filter/vaerker" : "filter/zzzz"} content={tag.name} cx="margin-r-s margin-l-s" />
              ) 
              )
              
            }



          
          {/* <Chip content="aquarel" cx="margin-r-s margin-l-s" />
          <Chip content="drawing" cx="margin-r-s margin-l-s" /> */}
        
      </div>
    
  
  }
}

export default FilterSection;